const inFlightRequests = new Map<string, Promise<unknown>>();

/**
 * Share only an in-progress request with callers using the same key.
 * Completed results are never cached, so subsequent reads stay fresh.
 */
export const shareInFlightRequest = <T>(
  key: string,
  requestFactory: () => Promise<T>,
): Promise<T> => {
  const existing = inFlightRequests.get(key) as Promise<T> | undefined;
  if (existing) return existing;

  let started: Promise<T>;
  try {
    started = requestFactory();
  } catch (error) {
    return Promise.reject(error);
  }
  let shared: Promise<T>;
  shared = started.finally(() => {
    if (inFlightRequests.get(key) === shared) {
      inFlightRequests.delete(key);
    }
  });
  inFlightRequests.set(key, shared);
  return shared;
};
